module.exports = __webpack_public_path__ + "static/media/logo-amazon.16b1596c.png";